import {AfterViewInit, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {TableModule} from "primeng/table";
import { CommonModule } from '@angular/common';
import {AppStateService} from "../../../service/app-state.service";
import {CantaaErrorHandlerService} from "../../../service/cantaa-error-handler.service";
import {NodeType} from "../../../constants/node-type";
import {WimTreeNode} from "../../../model/wim-tree.node";
import {TranslateModule} from '@ngx-translate/core';
import {ProjectConsumptionToolListItem} from '../../../model/project-consumption-tool-list.item';
import {ProjectConsumptionService} from '../../../service/project-consumption.service';
import {BaseGridComponent} from '../../base-components/base-grid.component';
import {GridRequest} from '../../../model/grid-request.model';

@Component({
  selector: 'wim-project-detail-consumption',
  standalone: true,
  imports: [
    TableModule,
    TranslateModule,
    CommonModule
  ],
  templateUrl: './project-detail-consumption.component.html',
  styleUrl: './project-detail-consumption.component.scss'
})
export class ProjectDetailConsumptionComponent extends BaseGridComponent<ProjectConsumptionToolListItem> implements AfterViewInit, OnInit {

  protected override nodeTypes = [NodeType.PROJECT];

  constructor(private appStateService: AppStateService,
              private projectConsumptionService: ProjectConsumptionService,
              private errorHandler: CantaaErrorHandlerService) {
    super();
  }

    override ngAfterViewInit(): void {

    console.log('ProjectDetailConsumptionComponent.ngAfterViewInit() called');
    if (!this.dataTable) {
      console.warn('dataTable is undefined');
    }
    super.ngAfterViewInit();
  }

  override async fetchGridItems(gridRequest: GridRequest, selectedNode: WimTreeNode) {

    try {
      return await this.fetchProjectConsumptionByProjectId(gridRequest, selectedNode!);
    } catch (e) {
      this.errorHandler.handleError(e, 'FAILED_TO_FETCH');
      throw e;
    }
  }

  private async fetchProjectConsumptionByProjectId(gridRequest: GridRequest, selectedNode: WimTreeNode) {
    try {
      const result = await this.projectConsumptionService.getProjectConsumption(selectedNode.id, gridRequest);
      this.dataLoaded = true;
      return result;
    } catch (e) {
      this.errorHandler.handleError(e, 'FAILED_TO_FETCH');
      throw e;
    }
  }
}
